import { useAppNavigate } from '@crm/hooks/useAppNavigate'
import { paths } from '@crm/routes'
import { getActivePath } from '@crm/utils'
import { Col, Menu, Row } from 'antd'

import { Category, RulerPen, TableDocument } from 'iconsax-react'
import { useTranslation } from 'react-i18next'
import { Outlet, useLocation } from 'react-router-dom'

import type { MenuProps } from 'antd/lib'

export const NomenclaturesProducts = () => {
  const { pathname } = useLocation()
  const { t } = useTranslation()
  const navigate = useAppNavigate()

  const items: MenuProps['items'] = [
    {
      key: paths.admin.nomenclatures.products.root,
      label: t('nomenclature.catalog'),
      icon: <TableDocument size={18} />,
      onClick: ({ key }) => navigate(key)
    },
    {
      key: paths.admin.nomenclatures.products.categories,
      label: t('nomenclature.categories'),
      icon: <Category size={18} />,
      onClick: ({ key }) => navigate(key)
    },
    {
      key: paths.admin.nomenclatures.products.unitMeasure,
      label: t('nomenclature.units_measure'),
      icon: <RulerPen size={18} />,
      onClick: ({ key }) => navigate(key)
    }
  ]

  return (
    <Row gutter={16} wrap={false}>
      <Col xs={8} lg={7} xl={6} xxl={5}>
        <Menu items={items} defaultSelectedKeys={[getActivePath(pathname)]} />
      </Col>

      <Col flex="auto">
        <Outlet />
      </Col>
    </Row>
  )
}
